module.exports = __webpack_public_path__ + "img/03.5be984f5.png";